module.exports = __webpack_public_path__ + "img/dinamo-tbilisi-logo-icon.8ead9f33.png";